import type { MapProvider } from '@/api'

// Every map a location link can open, in the order the Settings select lists them (the backend's `MapProvider`).
export const MAP_PROVIDERS: MapProvider[] = ['osm', 'geo', 'apple', 'apple_app', 'google', 'google_app']

// The i18n key below `settings.maps.` of a provider: `apple_app` is `appleApp`.
export function mapKey(provider: MapProvider): string {
  return provider.replace(/_([a-z])/g, (_, letter: string) => letter.toUpperCase())
}
